export default __webpack_public_path__ + "static/media/cog-wheel.a340f2d4.png";